// extracted by mini-css-extract-plugin
export default {"wrap":"SearchResults_wrap__Uz-3I"};